import { createRoot } from "react-dom/client";
import { App } from "./features/app";

document.body.style.overflow = "hidden";
document.body.style.height = "100dvh";

const root = createRoot(document.getElementById("root")!);

root.render(<App />);
